import React from "react";
import { __ } from "services/Translator";

// C-09. When the backend detects a responsible-gaming signal it stops the bot
// and hands the player to a person. Everything the player reads here is authored
// server-side and arrives in strings.rg already localized, because the wording
// of a gambling-harm response is a compliance decision, not a frontend one. The
// frontend renders whatever it is given and adds nothing.
//
// This is the ONLY assertive live region in the messenger. Everywhere else uses
// polite so an incoming reply never interrupts, but a player who has just
// disclosed harm must not have that response queued behind whatever else the
// screen reader is saying.
export default function RgHandoffView({ config, onBack }) {
  const rg = (config && config.strings && config.strings.rg) || {};
  const heading = rg.heading || null;
  const bodyLines = [];

  if (rg.body) {
    bodyLines.push(rg.body);
  }
  Object.keys(rg).forEach((key) => {
    if (key !== "heading" && key !== "body" && key !== "handoff_notice" && typeof rg[key] === "string") {
      bodyLines.push(rg[key]);
    }
  });

  return (
    <div className="supRg" role="alert" aria-live="assertive">
      <div className="supRgDivider">
        <span>{__("Connecting you to a person")}</span>
      </div>

      {heading && <h3 className="supRgHeading">{heading}</h3>}

      {bodyLines.length ? (
        bodyLines.map((line, index) => (
          <p className="supRgBody" key={index}>
            {line}
          </p>
        ))
      ) : (
        // The server owns this copy, but a player who has just reached out must
        // never be met with an empty panel if the strings have not been
        // published yet.
        <p className="supRgBody">
          {__("We are connecting you with someone from our team. You do not have to wait alone.")}
        </p>
      )}

      {rg.handoff_notice && <p className="supRgNotice">{rg.handoff_notice}</p>}

      {onBack && (
        <button type="button" className="supBtn supBtnGhost" onClick={onBack}>
          {__("Back to support")}
        </button>
      )}
    </div>
  );
}
